// Service Worker Registration and Update Management
// Handles PWA installation, updates, and lifecycle events
export function registerServiceWorker(config) {
    // Register service workers if supported (in both development and production)
    if (!('serviceWorker' in navigator)) {
        console.log('[App] Service Workers not supported in this browser');
        return;
    }
    const registerSW = async () => {
        try {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
            const registration = await navigator.serviceWorker.register(swUrl, {
                scope: '/'
            });
            console.log('[App] Service Worker registered:', registration);
            // Force SW to take control immediately
            if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
            // Listen for SW controller change
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                console.log('[App] Service Worker is now controlling the page');
            });
            // Check for updates periodically (every hour)
            setInterval(() => {
                registration.update();
            }, 60 * 60 * 1000);
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (installingWorker == null) {
                    return;
                }
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            // New update available
                            console.log('[App] New content available; please refresh.');
                            if (config && config.onUpdate) {
                                config.onUpdate(registration);
                            }
                        }
                        else {
                            // Content cached for offline use
                            console.log('[App] Content cached for offline use.');
                            if (config && config.onSuccess) {
                                config.onSuccess(registration);
                            }
                        }
                    }
                };
            };
        }
        catch (error) {
            console.error('[App] Service Worker registration failed:', error);
            if (config && config.onError) {
                config.onError(error);
            }
        }
    };
    // Register immediately, don't wait for page load
    registerSW();
    // Listen for messages from the service worker
    navigator.serviceWorker.addEventListener('message', (event) => {
        console.log('[App] Message from Service Worker:', event.data);
        if (event.data && event.data.type === 'SYNC_COMPLETE') {
            // Handle sync completion
            console.log('[App] Offline sync completed at:', new Date(event.data.timestamp));
        }
    });
}
export function unregisterServiceWorker() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
            registration.unregister();
            console.log('[App] Service Worker unregistered');
        })
            .catch((error) => {
            console.error('[App] Service Worker unregistration failed:', error);
        });
    }
}
// Helper to skip waiting and activate new service worker immediately
export function skipWaiting() {
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
    }
}
// Helper to clear all caches
export async function clearAllCaches() {
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        return new Promise((resolve) => {
            const messageChannel = new MessageChannel();
            messageChannel.port1.onmessage = (event) => {
                resolve(event.data.success);
            };
            navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' }, [messageChannel.port2]);
        });
    }
    return false;
}
// Check if app is running in standalone mode (installed as PWA)
export function isStandalone() {
    // Check if running in standalone mode
    const isInStandaloneMode = ('standalone' in window.navigator && window.navigator.standalone) || // iOS
        window.matchMedia('(display-mode: standalone)').matches; // Android/Desktop
    return isInStandaloneMode;
}
// Request persistent storage
export async function requestPersistentStorage() {
    if (navigator.storage && navigator.storage.persist) {
        const isPersisted = await navigator.storage.persist();
        console.log(`[App] Persistent storage granted: ${isPersisted}`);
        return isPersisted;
    }
    return false;
}
